import React, { useEffect, useState } from "react";
import useDebounce from "../hooks/useDebounce";

const NexratesCounterpartiesListFilter : React.FC<{
    onFilterChange: (code: string, description: string, salesBook: string, site: string, showInactive: boolean) => void
}> = ({onFilterChange}) => {

    const [filterCode, setFilterCode] = useState<string>("");
    const [filterDescription, setFilterDescription] = useState<string>("");
    const [filterSalesBook, setFilterSalesBook] = useState<string>("");
    const [filterSite, setFilterSite] = useState<string>("");
    const [filterShowInactive, setFilterShowInactive] = useState<boolean>(false);
    const [filter, setFilter] = useState<{code: string, description: string, salesBook: string, site: string, showInactive: boolean}>({code: "", description: "", salesBook: "", site: "", showInactive: false});

    const debouncedFilter = useDebounce(filter, 300);

    useEffect(() => {
        setFilter({code: filterCode, description: filterDescription, salesBook: filterSalesBook, site: filterSite, showInactive: filterShowInactive});
    }, [filterCode, filterDescription, filterSalesBook, filterSite, filterShowInactive]);

    useEffect(() => {
        onFilterChange(debouncedFilter.code, debouncedFilter.description, debouncedFilter.salesBook, debouncedFilter.site, debouncedFilter.showInactive); 
    }, [debouncedFilter, onFilterChange])

    return <tr>
        <th><input type="text" style={{width: "100%"}} value={filterCode} onChange={e => setFilterCode(e.target.value)}/></th>
        <th><input type="text" style={{width: "100%"}} value={filterDescription} onChange={e => setFilterDescription(e.target.value)}/></th>
        <th><input type="text" style={{width: "100%"}}  value={filterSalesBook} onChange={e => setFilterSalesBook(e.target.value)} /></th>
        <th><input type="text" style={{width: "100%"}}  value={filterSite} onChange={e => setFilterSite(e.target.value)}/></th>
        <th><input type="checkbox" checked={filterShowInactive} onChange={e => setFilterShowInactive(e.target.checked)} /> Show Inactive</th>
    </tr>;
};

export default React.memo(NexratesCounterpartiesListFilter);